import { css } from '@emotion/react';

import { useValuationContext } from '@widget/valuation';
import { Box, Heading, Text } from '@toolbox/components';
import { makeStyles } from '@toolbox/style';

const useStyles = makeStyles(({ theme }) => ({
  valuation: css`
    text-align: center;
    width: 100%;
    margin-bottom: ${theme.spacing(2)};
  `,
}));

const loyaltySVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="currentColor"
  >
    <path d="M28.5465 15.4401L16.5465 3.44008C16.0665 2.96008 15.3998 2.66675 14.6665 2.66675H5.33317C3.8665 2.66675 2.6665 3.86675 2.6665 5.33341V14.6667C2.6665 15.4001 2.95984 16.0667 3.45317 16.5601L15.4532 28.5601C15.9332 29.0401 16.5998 29.3334 17.3332 29.3334C18.0665 29.3334 18.7332 29.0401 19.2132 28.5467L28.5465 19.2134C29.0398 18.7334 29.3332 18.0667 29.3332 17.3334C29.3332 16.6001 29.0265 15.9201 28.5465 15.4401ZM7.33317 9.33342C6.2265 9.33342 5.33317 8.44008 5.33317 7.33342C5.33317 6.22675 6.2265 5.33341 7.33317 5.33341C8.43984 5.33341 9.33317 6.22675 9.33317 7.33342C9.33317 8.44008 8.43984 9.33342 7.33317 9.33342ZM23.0265 20.3601L17.3332 26.0534L11.6398 20.3601C11.0398 19.7467 10.6665 18.9201 10.6665 18.0001C10.6665 16.1601 12.1598 14.6667 13.9998 14.6667C14.9198 14.6667 15.7598 15.0401 16.3598 15.6534L17.3332 16.6134L18.3065 15.6401C18.9065 15.0401 19.7465 14.6667 20.6665 14.6667C22.5065 14.6667 23.9998 16.1601 23.9998 18.0001C23.9998 18.9201 23.6265 19.7601 23.0265 20.3601Z" />
  </svg>
);

export const ValuationHeaderV3 = (): JSX.Element | null => {
  const { valuation } = useValuationContext();
  const classes = useStyles();

  if (!valuation) return null;

  return (
    <Box css={classes.valuation as any}>
      <span>{loyaltySVG}</span>
      <Text variant="b2">Erwartete Preisspanne</Text>
      <Heading variant="h4" as="p">
        {valuation}
      </Heading>
    </Box>
  );
};
